import { Box, Card, Center, Stack, Text, Title } from "@mantine/core";
import { BecomePatreonButton } from "./become-patreon-button";
import { UnlinkPateronButton } from "./unlink-patreon-button";

export function UnsubscribedPatreonCard() {
  return (
    <Card withBorder maw={500}>
      <Center>
        <Title mb="md">
          Become a{" "}
          <Text inherit span c="orange">
            Patreon
          </Text>
        </Title>
      </Center>
      <Stack>
        <Text>
          It looks like you've linked your Patreon account but are currently{" "}
          <b>not subscribed</b>. If you'd like to gain{" "}
          <Text span c="pink">
            early access
          </Text>{" "}
          to the site please click the{" "}
          <Text inherit span c="orange">
            Become a Patreon
          </Text>{" "}
          link below.
        </Text>
        <Text>
          Or if you prefer to use <em>another</em> Patreon account you could
          also <b>unlink</b> the current one below.
        </Text>
      </Stack>
      <Box p="xl">
        <Stack gap="md">
          <Title size="h3">Subscribe</Title>
          <BecomePatreonButton />
          <Title size="h3">Unlink Patreon Account</Title>
          <UnlinkPateronButton />
        </Stack>
      </Box>
    </Card>
  );
}
